import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _MoveCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2", clipRule: "evenodd" })));
}
const MoveCustom = forwardRef(_MoveCustom);
export { MoveCustom };
